import { call, put, select, takeLatest } from "redux-saga/effects";

import * as corporateCardMiddleware from "middleware/corporateCard";
import { actions, selectors, types } from "reducers/corporateCard";
import { actions as notificationActions } from "reducers/notification";
import { downloadPdf } from "util/download";
import * as i18n from "util/i18n";

const sagas = [
    takeLatest(types.LIST_STATEMENTS_REQUEST, listStatementsSaga),
    takeLatest(types.DOWNLOAD_STATEMENT_REQUEST, downloadStatementSaga),
];

export default sagas;

function* listStatementsSaga({ year }) {
    try {
        const response = yield call(corporateCardMiddleware.listAccountStatements, year);

        if (response && response.status === 200) {
            const { statements } = response.data.data || {};

            yield put(actions.listStatementsSuccess(statements || [], null, null));
        } else {
            yield put(actions.listStatementsError(response?.data?.message || i18n.get("global.unexpectedError")));
        }
    } catch (error) {
        const errorMessage = error?.response?.data?.message || error?.message || i18n.get("global.unexpectedError");
        yield put(actions.listStatementsError(errorMessage));
    }
}

function* downloadStatementSaga({ fileName }) {
    const isDownloading = yield select(selectors.getIsDownloading);
    const downloadingFileName = yield select(selectors.getDownloadingFileName);

    if (isDownloading && downloadingFileName !== fileName) {
        yield put(
            notificationActions.showNotification(
                i18n.get("corporateCard.accountStatements.download.inProgress") || "Ya hay una descarga en progreso",
                "warning",
                ["corporateCard"],
            ),
        );
        return;
    }

    try {
        const response = yield call(corporateCardMiddleware.downloadAccountStatement, fileName);

        if (response && response.status === 200) {
            const { content, fileName: responseFileName } = response.data.data || {};

            if (content) {
                downloadPdf(responseFileName || fileName, content);

                yield put(actions.downloadStatementSuccess());
                yield put(
                    notificationActions.showNotification(
                        i18n.get("corporateCard.accountStatements.download.success") ||
                            i18n.get("global.download.success"),
                        "success",
                        ["corporateCard"],
                    ),
                );
            } else {
                throw new Error("No se recibió contenido del archivo");
            }
        } else {
            const errorMessage = response?.data?.message || i18n.get("global.unexpectedError");
            yield put(actions.downloadStatementError(errorMessage));
            yield put(
                notificationActions.showNotification(
                    i18n.get("corporateCard.accountStatements.download.error") || i18n.get("global.unexpectedError"),
                    "error",
                    ["corporateCard"],
                ),
            );
        }
    } catch (error) {
        const errorMessage = error?.response?.data?.message || error?.message || i18n.get("global.unexpectedError");
        yield put(actions.downloadStatementError(errorMessage));
        yield put(
            notificationActions.showNotification(
                i18n.get("corporateCard.accountStatements.download.error") || i18n.get("global.unexpectedError"),
                "error",
                ["corporateCard"],
            ),
        );
    }
}
